
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter_favorable)"}},[_c('path',{attrs:{"d":"M10 4l1.42 4.05 4.29.1-3.42 2.6 1.24 4.1L10 12.41l-3.53 2.44 1.24-4.1-3.42-2.6 4.3-.1L10 4z","fill":"#1DCA6E"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter_favorable","x":".29","y":"0","width":"19.41","height":"18.85","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.113725 0 0 0 0 0.792157 0 0 0 0 0.431373 0 0 0 1 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    